module.exports = __webpack_public_path__ + "img/not-accept-registration-en.7746cab.png";